import {isoToLocalDate, isUUID} from "../stores/StoreUtilities";
import IModelItem from "./IModelItem";

export enum MilestoneId {
  retirement1= "retirement1",
  retirement2 = "retirement2",
  earliestRetirement = "earliestRetirement",
  latestRetirement = "latestRetirement",
  lifeExpectancy1 = "lifeExpectancy1",
  lifeExpectancy2 = "lifeExpectancy2",
  earliestLifeExpectancy = "earliestLifeExpectancy",
  latestLifeExpectancy = "latestLifeExpectancy"
}

class Milestone implements IModelItem {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  modelId: string
  description: string
  archived: boolean
  label: string
  date: string
  age: number

  constructor (data: any) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.accountId = data.accountId
    this.userId = data.userId
    this.modelId = data.modelId
    this.label = data.label
    this.description = data.description
    this.archived = data.archived ?? false
    this.date = data.date
    this.age = data.age ?? 0
  }

  getTypename(): string {
    return "Milestone"
  }

  get isCustom(): boolean {
    return isUUID(this.id)
  }
}

export default Milestone